import Layout from '../../internal/Layout.vue'
import ManagePage from './manage.vue'
import ConsumptionPage from './Consumption.vue'

const ConsumptionRoutes = {
  component: Layout,
  children: [
    {
      name: 'Comsumption',
      path: '/',
      component: ConsumptionPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
        requiresWorkshopInstitution: true,
      },
    },
    {
      name: 'manage',
      path: 'manage',
      component: ManagePage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
        requiresWorkshopInstitution: true,
      },
    },
  ],
}

export default ConsumptionRoutes
